export const localStorageKeys = {
  SUBSIDIARY            : 'subsidiary',
  CORPORATIVE           : 'corporative',
};
